import React, { useContext } from 'react';

import { SnackbarNotification } from '@/config/types';

import { resetSnackbarNotification } from '../shared/actions/resetSnackbarNotification';
import { setSnackbarNotification } from './actions/setSnackbarNotification';
import { updateNotificationsContext } from './actions/updateNotificationsContext';

const actionsDefinitions = (setStateById: (id: string, stateChange: stateChangeInNotificationsContext) => void) => ({
  updateNotificationsContext: updateNotificationsContext(setStateById),
  setSnackbarNotification: setSnackbarNotification(setStateById),
  resetSnackbarNotification: resetSnackbarNotification(setStateById),
});

export const notificationsState = {
  nextId: undefined as string | undefined,
  snackbarNotification: undefined as SnackbarNotification | undefined,
};

const NotificationsContext = React.createContext({
  state: notificationsState,
  actions: actionsDefinitions(() => () => {}),
});

export type action = (setState: setStateInNotificationsContext, actionId: string) => () => void;

export type stateChangeInNotificationsContext = (prevState: typeof notificationsState) => typeof notificationsState;
export type setNotificationsStateById = (id: string, stateChange: stateChangeInNotificationsContext) => void;
export type setStateInNotificationsContext = React.Dispatch<stateChangeInNotificationsContext>;

export const useNotificationsContext = () => useContext(NotificationsContext);

export function NotificationsContextProvider(props) {
  const [state, setState] = React.useState(notificationsState);
  const setStateById: setNotificationsStateById = (_, stateChange) => {
    setState(stateChange);
  };

  const actions = actionsDefinitions(setStateById);
  return <NotificationsContext.Provider value={{ state, actions }}>{props.children}</NotificationsContext.Provider>;
}
